import React from 'react';
import { useIsFeatureEnabled } from '@innovyze/stylovyze';
import { FilterCard as EsriFilterCard } from '@Map/esri/features/FilterCard/FilterCard';
import { FilterCard as MapComponentsFilterCard } from '@innovyze/map-components';

export interface FilterCardProps {
	/**
	 * Number of active filters to display.
	 * Used only in Mapbox mode — in Esri mode the count is read from Redux.
	 */
	filterCount?: number;
}

/**
 * Feature-flag–driven FilterCard wrapper.
 *
 * In Esri mode the filter count is read internally from Redux state so
 * `filterCount` is intentionally ignored.
 *
 * When `info360-platform-esri-map` is enabled the Esri implementation is
 * rendered; otherwise the legacy `@innovyze/map-components` version is used.
 */
const FilterCard = ({ filterCount }: FilterCardProps): JSX.Element | null => {
	const isEsri = Boolean(useIsFeatureEnabled('info360-platform-esri-map'));

	if (isEsri) {
		return <EsriFilterCard />;
	}

	return <MapComponentsFilterCard filterCount={filterCount} />;
};

export default FilterCard;
